//  Node modules
import { Emitter } from "@quest/pixi-bridge";
import { EventConstants as platformEventConstants } from "@quest/platform-murka-phase_2/dist/EventConstants";
import { Container, IEvent, Label, Linear, SpineBase, delayedCall, detectDeviceEnvironmentConstants, dispatcher, ingenuity, killDelayedCall } from "@quest/base-core/dist";

// Class modules
import { eventDispatchers } from "../Constants/EventDispatchers";
import { JackpotWonFeatureView } from "./JackpotWonFeatureView";
import { GameParserModel } from "../Platform/GameParserModel";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { MeterBehavior, SlotConstantsBehavior, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-panther/dist";
import { gameConstants } from "../Constants/gameConstants";

export class JackpotWonFeatureController {
  // class variable
  private view: JackpotWonFeatureView;
  private jackpotType: string;
  private jackpotWinAmt: number = 0;
  // Class variable for Jackpot UI
  private jackpotOutroContainer: Container;
  private jackpotOutroSpine: SpineBase;
  private JpOutroWinAmount: MeterBehavior;
  // Class variable for Emitter vairables
  private emitter2: Emitter;
  private coinShowerContainerMask: any;
  private jpOutroDesktopSpineContainer: Container;
  private jpOutroPortraitSpineContainer: Container;
  private jpOutroPortraitSpine: SpineBase;
  private continueText: Label;
  private jackpotOutroPopupBG: any;
  private winAmountContainer: Container;
  /**
   * Class constructor
   * @param view
   */
  constructor(view: JackpotWonFeatureView) {
    this.view = view;
    this.initializeElements();
    this.subscribeEvents();
  }

  /**
   * Method to initialize class UI elements
   */
  private initializeElements(): void {
    this.jackpotOutroContainer = this.view.getContainerByID("jackpotOutroContainer");
    this.jpOutroDesktopSpineContainer = this.view.getContainerByID("jpOutroSpineDesktopContainer");
    this.jackpotOutroSpine = this.jpOutroDesktopSpineContainer.children[0];
    this.JpOutroWinAmount = this.view.getMeterById("JpOutroWinAmount") as MeterBehavior;
    if (!ingenuity.deviceEnv.isDesktop) {
      this.jpOutroPortraitSpineContainer = this.view.getContainerByID("jpOutroSpinePortraitContainer");
      this.jpOutroPortraitSpine = this.jpOutroPortraitSpineContainer.children[0];
    }
    this.continueText = this.view.getLabelById("continueText") as Label;
    this.jackpotOutroPopupBG = this.view.getShapeById("jackpotOutroPopupBG");
    this.winAmountContainer = this.view.getContainerByID('winAmountContainer');
    this.coinShowerContainerMask = this.view.getShapeById("coinShowerContainerMask") as any;
    if (!ingenuity.deviceEnv.isDesktop) {
      this.coinShowerContainerMask.y = this.view.json.Y_POSITION[1];
    }
    this.jackpotOutroPopupBG.x = -1005;
    this.jackpotOutroPopupBG.y = -187;
  }

  /**
   * Class method to subscribe events
   */
  private subscribeEvents(): void {
    this.unSubscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_JACKPOT_OUTRO, this.showJackpotOutro, this);
    dispatcher.on(eventDispatchers.UPDATE_WIN_AMT_POS,this.updateElementsPosition,this)
  }

  /**
   * Class method to subscribe events
   */
  private unSubscribeEvents(): void {
    dispatcher.off(eventDispatchers.SHOW_JACKPOT_OUTRO, this.showJackpotOutro, this);
    dispatcher.off(eventDispatchers.UPDATE_WIN_AMT_POS,this.updateElementsPosition,this)
  }

  /**
   * Jp outro presentaiton starts from here
   */
  private showJackpotOutro(data: IEvent): void {
    this.getJPType(data.data);
    this.view.showView();
    this.startCoinShowerAnim();
  }

  private getJPType(JPType: string): void {
    let currentBet: number = ingenuity.parserModel.getCurrentTotalBet();
    switch (JPType) {
      case "grand":
        this.jackpotType = "grand";
        this.jackpotWinAmt = (ingenuity.parserModel as GameParserModel).getJackpotAmount();
        this.jackpotOutroSpine = this.jpOutroDesktopSpineContainer.children[0];
        if (!ingenuity.deviceEnv.isDesktop) {
          this.jpOutroPortraitSpine = this.jpOutroPortraitSpineContainer.children[0];
        }
        break;
      case "major":
        this.jackpotType = "major";
        this.jackpotWinAmt = currentBet * (ingenuity.parserModel as GameParserModel).getJackpotData().major;
        this.jackpotOutroSpine = this.jpOutroDesktopSpineContainer.children[1];
        if (!ingenuity.deviceEnv.isDesktop) {
          this.jpOutroPortraitSpine = this.jpOutroPortraitSpineContainer.children[1];
        }
        break;
      case "minor":
        this.jackpotType = "minor";
        this.jackpotWinAmt = currentBet * (ingenuity.parserModel as GameParserModel).getJackpotData().minor;
        this.jackpotOutroSpine = this.jpOutroDesktopSpineContainer.children[2];
        if (!ingenuity.deviceEnv.isDesktop) {
          this.jpOutroPortraitSpine = this.jpOutroPortraitSpineContainer.children[2];
        }
        break;
      case "mini":
        this.jackpotType = "mini";
        this.jackpotWinAmt = currentBet * (ingenuity.parserModel as GameParserModel).getJackpotData().mini;
        this.jackpotOutroSpine = this.jpOutroDesktopSpineContainer.children[3];
        if (!ingenuity.deviceEnv.isDesktop) {
          this.jpOutroPortraitSpine = this.jpOutroPortraitSpineContainer.children[3];
        }
        break;
      default:
        this.jackpotType = "grand";
        this.jackpotWinAmt = (ingenuity.parserModel as GameParserModel).getJackpotAmount();
        this.jackpotOutroSpine = this.jpOutroDesktopSpineContainer.children[0];
        if (!ingenuity.deviceEnv.isDesktop) {
          this.jpOutroPortraitSpine = this.jpOutroPortraitSpineContainer.children[0];
        }
    }
  }

  /**
   * update win elements position on orientation change
   */
  private updateElementsPosition():void{
    this.addRemoveCoinShowerMask();
    this.setCoinShowerPosition();
    if(!this.winAmountContainer.transform) return;
   if(!ingenuity.deviceEnv.isDesktop){
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      if(this.jackpotType !== "grand"){
      this.winAmountContainer.y = 190;
      this.jpOutroPortraitSpineContainer.y = 115;
      } else {
        this.winAmountContainer.y = 340;
        this.jpOutroPortraitSpineContainer.y = 269;
      }
    } else if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.LANDSCAPE){
      if(this.jackpotType == "grand"){
        this.winAmountContainer.y = 370;
      } else {
        this.winAmountContainer.y = 254;

      }
    }
   } else {
    if( this.jackpotType == "grand"){
      this.winAmountContainer.y = -5;
    } else {
      this.winAmountContainer.y = -115;
    }
    }
     if (ingenuity.deviceEnv.device === gameConstants.IPAD) {
      if( this.jackpotType !== "grand"){
      this.jpOutroPortraitSpineContainer.y = 160;
      if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
        this.winAmountContainer.y = 230
     }
        else {
          this.winAmountContainer.y = 253
        }
     } else {
      if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
        this.winAmountContainer.y = 340;
      } else {
        this.winAmountContainer.y = 370;

      }
      this.jpOutroPortraitSpineContainer.y = 265 ;
     }
      }

  }

  private setCoinShowerPosition(): void {
    const coinShowerContainer2: Container = this.view.getContainerByID("coinShowerContainer2");
    if(!coinShowerContainer2.transform) return;
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      coinShowerContainer2.y = 296;
    } else {
      if(this.jackpotType == 'grand'){
        coinShowerContainer2.y = 296;
      } else {
        coinShowerContainer2.y = 266;
      }
    }
   
  }

  /**
   * This method starts the coin shower animation
   */
  private startCoinShowerAnim(): void {
    this.ShowJackpotOutroView();
  }

  /**
   * This method shows the jackpot outro view UI
   */
  private ShowJackpotOutroView(): void {
    this.jackpotOutroContainer.visible = true;
    this.updateElementsPosition();
    if (ingenuity.deviceEnv.isDesktop) {
      this.playJackpotOutroAnim();
    } else {
      this.playJackpotOutroAnim();
      this.playJackpotOutroPortraitAnim();
    }
  }

  /**
   * This method start the coin shower fountaion animation
   */
  private startCoinShowerFountainAnim(): void {
    this.initializeCoinShowerFountainEmitter();
    this.startCoinShowerFountainEmitter();
  }

  /**
   * This method initialized the elements for Coin shower fountain emitter
   */
  private initializeCoinShowerFountainEmitter(): void {
    const particleData: any = {
      emitterType: 1,
      id: "winCoinEmitter_3",
      autoStart: false,
      animConfig: [
        {
          framerate: 30,
          loop: true,
          image: "Coin_rotation",
          generateFrames: true,
          frames: [0, 14],
        },
      ],
    };
    const config = {
      alpha: {
        start: 1,
        end: 0.22,
      },
      scale: {
        start: 1.5,
        end: 1,
        minimumScaleMultiplier: 0.5,
      },
      color: {
        start: "#ffffff",
        end: "#ffffff",
      },
      speed: {
        start: 700,
        end: 200,
        minimumSpeedMultiplier: 1,
      },
      acceleration: {
        x: 0,
        y: 0,
      },
      maxSpeed: 0,
      startRotation: {
        min: 0,
        max: -180,
      },
      noRotation: false,
      rotationSpeed: {
        min: 0,
        max: 10,
      },
      lifetime: {
        min: 4,
        max: 4,
      },
      blendMode: "normal",
      frequency: 0.029,
      emitterLifetime: -1,
      maxParticles: 500,
      pos: {
        x: 666,
        y: 180,
      },
      addAtBack: false,
      spawnType: "point",
    };
    this.setCoinShowerPosition();
    const coinShowerContainer2: Container = this.view.getContainerByID("coinShowerContainer2");
    this.addRemoveCoinShowerMask();
    ingenuity.currentGame.add.emitter(coinShowerContainer2, particleData, config) as Emitter;
  }


  private addRemoveCoinShowerMask():void{
    const coinShowerContainer2: Container = this.view.getContainerByID("coinShowerContainer2");
    if (ingenuity.deviceEnv.getOrientation() == detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      coinShowerContainer2.mask = null;
    } else {
      if (ingenuity.deviceEnv.device === gameConstants.IPAD) {
        this.coinShowerContainerMask.y = -120;
        coinShowerContainer2.mask = this.coinShowerContainerMask;
      }
      coinShowerContainer2.mask = this.coinShowerContainerMask;
    }
  }

  /**
   * This method start the 3rd emitter
   * @returns
   */
  private startCoinShowerFountainEmitter(): void {
    this.emitter2 = ingenuity.currentGame.particles.getEmitterById("winCoinEmitter_3");
    this.emitter2.autoUpdate = true;
    this.emitter2.emit = true;
  }

  /**
   * Class method, play the jackpot outro animation spine
   */
  private playJackpotOutroAnim(): void {
    this.jackpotOutroSpine.visible = true;
    dispatcher.fireEvent(eventDispatchers.SHOW_JACKPOT_BG,{action:'intro'});
    this.jackpotOutroSpine.playAnim("in", false);
    this.jackpotOutroSpine.onComplete.addOnce(() => {
      this.onJackpotOutroAnimComplete();
    }, this);
  }

  /**
   * Class method, play the jackpot outro portrait animation spine
   */
  private playJackpotOutroPortraitAnim(): void {
    this.jpOutroPortraitSpine.visible = true;
    this.jpOutroPortraitSpine.playAnim("in", false);
    this.jpOutroPortraitSpine.onComplete.addOnce(() => {
      this.jpOutroPortraitSpine.playAnim("loop", true);
    }, this);
  }

  /**
   * Class method hide the jackpotUI ater outro spine completeed
   */
  private onJackpotOutroAnimComplete(): void {
    this.view.getContainerByID("coinShowerContainer2").removeChildren();
    this.showJpOutroLoopSpine();
  }

  /**
   * Show Jp outro loop spine
   */
  private showJpOutroLoopSpine(): void {
    this.startCoinShowerFountainAnim();
    dispatcher.fireEvent(eventDispatchers.SHOW_JACKPOT_BG,{action:'idle'});
    this.jackpotOutroSpine.playAnim("loop", true);
    this.startJpOutroWinAmountTickup();
    //this.tweenOutroAmountContainer();
  }
  /* to show jp outro win amount tickup */
  private startJpOutroWinAmountTickup(): void {
    if ((ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.BONUS_BGM, SlotConstantsBehavior.SOUND_LIST_PRELOAD)) {
      (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.BONUS_BGM, SlotConstantsBehavior.SOUND_LIST_PRELOAD).volume = 0.4;
    }
    this.playJpSound();
    this.winAmountContainer.visible = true;
    this.JpOutroWinAmount.setValue(0);
    this.JpOutroWinAmount.visible = true;
    this.JpOutroWinAmount.alpha = 1;
    this.JpOutroWinAmount &&
      this.JpOutroWinAmount.startTick(this.jackpotWinAmt, true, false, 6.5, true, this.showContinueButton.bind(this));
  }

  private playJpSound():void{
    switch (this.jackpotType){
      case 'grand':
              (ingenuity.soundManager as any).playSound(SoundConstantGame.JP_WON_OUTRO_GRAND, 1, true, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
        break;
      case "major":
        (ingenuity.soundManager as any).playSound(SoundConstantGame.JP_WON_OUTRO_MAJOR, 1, true, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
        break;
      case "minor":
        (ingenuity.soundManager as any).playSound(SoundConstantGame.JP_WON_OUTRO_MINOR, 1, true, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
        break;
      case "mini":
        (ingenuity.soundManager as any).playSound(SoundConstantGame.JP_WON_OUTRO_MINI, 1, true, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
        break;
      default:
        (ingenuity.soundManager as any).playSound(SoundConstantGame.JP_WON_OUTRO_GRAND, 1, true, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
    }
  }

  private stopJpSound(): void {
    switch (this.jackpotType) {
      case "grand":
        (ingenuity.soundManager as any).stop(SoundConstantGame.JP_WON_OUTRO_GRAND, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
        break;
      case "major":
        (ingenuity.soundManager as any).stop(SoundConstantGame.JP_WON_OUTRO_MAJOR, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
        break;
      case "minor":
        (ingenuity.soundManager as any).stop(SoundConstantGame.JP_WON_OUTRO_MINOR, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
        break;
      case "mini":
        (ingenuity.soundManager as any).stop(SoundConstantGame.JP_WON_OUTRO_MINI, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
        break;
      default:
    }
  }

  /**to show continue button */
  private showContinueButton(): void {
    this.onStageClick();
    this.continueText.visible = true;
    this.stopJpSound();
    if ((ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.BONUS_BGM, SlotConstantsBehavior.SOUND_LIST_PRELOAD)) {
      (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.BONUS_BGM, SlotConstantsBehavior.SOUND_LIST_PRELOAD).volume = 1;
    }
  }

  onStageClick() {
    this.jackpotOutroPopupBG.interactive = true;
    this.jackpotOutroPopupBG.inputEnabled = true;
    this.jackpotOutroPopupBG &&
      this.jackpotOutroPopupBG.events.onInputUp.add((e: any) => {
        this.onContinuePressUP();
        this.offStageClick();
      }, this);
  }
  offStageClick() {
    this.jackpotOutroPopupBG.interactive = false;
    this.jackpotOutroPopupBG.inputEnabled = false;
    this.jackpotOutroPopupBG && this.jackpotOutroPopupBG.events.onInputUp.dispose();
  }

  /**
   * tween win amount
   */
  // private tweenOutroAmountContainer(): void {
  //   ingenuity.currentGame.add.tween(this.winAmountContainer.scale).to({ x: 1.05, y: 1.02 }, 700, Linear.None, true, 0, -1, true);
  // }

  /*to handle continue button pressup */
  private onContinuePressUP(): void {
    this.continueText.visible = false;
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: SoundConstant.COMMON_CLICK_SOUND, vol: 1, loop: false });
    this.onJpOutroSlideUp();
  }

  /**
   * Slide up the jackpot outro
   */
  private onJpOutroSlideUp(): void {
    if (ingenuity.deviceEnv.isDesktop) {
      this.playJackpotWinEndAnim();
    } else {
      this.playJackpotWinEndAnim();
      this.playJackpotWinPortraitEndAnim();
    }
    this.playJackpotAmtFadeTween();
    if (this.jackpotType == "grand") {
      let value : number =this.jackpotWinAmt + (ingenuity.parserModel as GameParserModel).getBaseGameWinAmt();
      (ingenuity.parserModel as GameParserModel).setBaseGameWinAmt(value);
      dispatcher.fireEvent(platformEventConstants.UPDATE_BS_WIN, {
        value,
      });
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
    }
  }

  /**
   * Class method to hide jackpot amount fade out tween
   */
  private playJackpotAmtFadeTween(): void {
    const jpAmountFadeOutTween = ingenuity.currentGame.add
      .tween(this.JpOutroWinAmount)
      .to({ alpha: 0 }, 100, Linear.None, true, 0, 0, false);
    jpAmountFadeOutTween.onComplete.addOnce(() => {
      this.emitter2.emit = false;
      jpAmountFadeOutTween.stop();
      ingenuity.currentGame.tweens.remove(jpAmountFadeOutTween);
      this.JpOutroWinAmount.visible = false;
    }, this);
  }

  /**
   * This method plays the jackpot win end animation that slide up the jackpot banner
   */
  private playJackpotWinEndAnim(): void {
    this.jackpotOutroSpine.playAnim("out", false);
    this.winAmountContainer.visible = false;
    this.jackpotOutroSpine.onComplete.addOnce(() => {
      dispatcher.fireEvent(eventDispatchers.SHOW_JACKPOT_BG,{action:'outro'});
      delayedCall('startNextStep',SlotConstantsBehavior.DURATION_400,()=>{
        killDelayedCall('startNextStep');
        this.onJackpotWinEndAnimComplete();
      })
    }, this);
  }

  /**
   * This method plays the jackpot win end portrait animation that slide up the jackpot banner
   */
  private playJackpotWinPortraitEndAnim(): void {
    //this.jpOutroPortraitSpineBG.playAnim("jackpot_outro_bg_portrait", false);
    this.jpOutroPortraitSpine.playAnim("out", false);
    this.jpOutroPortraitSpine.onComplete.addOnce(() => {
      this.jpOutroPortraitSpine.visible = false;
    }, this);
  }

  /**
   * Hide the jackpot outro and fire event for win collection
   */
  private onJackpotWinEndAnimComplete(): void {
    this.jackpotOutroContainer.visible = false;
    this.jackpotOutroSpine.visible = false;
    //this.jackpotOutroSpineBG.visible = false;
    this.view.hideView();
    if (this.jackpotType == "grand") {
      dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
    } else {
      dispatcher.fireEvent(eventDispatchers.RESUME_WIN_COLLECTION);
    }
  }
}
